module.exports = __webpack_public_path__ + "static/gallery_wild_3_thumb-7ccae31482c2fdf8649ce0578924085f.jpg";